import type { ReactNode } from 'react';

export const symbol_drive_file_move: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18.5T80-220v-520q0-23 18-41.5t42-18.5h256q12.44 0 23.72 5t19.37 13.09L481-740h339q23 0 41.5 18.5T880-680v460q0 23-18.5 41.5T820-160H140Zm0-60h680v-460H456l-60-60H140v520Zm0 0v-520 520Zm386-190-54 54q-9 9-9 21t9 21q9 9 21 9t21-9l105-105q9-9 9-21t-9-21L514-566q-9-9-21-9t-21 9q-9 9-9 21t9 21l54 54H350q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5h176Z"
		/>
	</svg>
);
